var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6ED5EDE0-337F-4834-A1BA-847AEA0DF0E0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-881.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(882.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.69094,22.34545 C44.69094,34.68645 34.68654,44.69085 22.34544,44.69085 C10.00444,44.69085 4e-05,34.68645 4e-05,22.34545 C4e-05,10.00435 10.00444,-5e-05 22.34544,-5e-05 C34.68654,-5e-05 44.69094,10.00435 44.69094,22.34545 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.01604,28.18813 C18.06974,28.45023 18.09784,28.72173 18.09784,28.99983 C18.09784,31.22423 16.49354,33.02753 14.26914,33.02753",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.45759,13.38119 L31.40079,13.38119 C31.40079,13.38119 28.39459,13.05129 28.68689,12.17439 C28.97919,11.29729 29.62879,9.96559 29.62879,9.96559 L25.66609,8.92619 L24.04199,13.11629",
    id: "Stroke-5",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15993,25.89535 L27.15993,37.18515 C27.15993,37.80225 26.09733,37.96465 26.09733,37.96465 C26.09733,37.96465 25.14633,37.89975 25.14633,36.89285 L25.14633,30.94905 C25.14633,29.55195 24.96873,27.45355 22.78383,25.72555",
    id: "Stroke-7",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19.77907 27.75453 19.77907 32.18303 21.80077 32.18303 21.80077 26.75513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71926,34.55893 L7.42486,34.55893 L7.42486,33.48253 L7.47536,33.38103 C8.07226,32.18783 8.38746,30.85233 8.38746,29.51853 L8.38746,23.48873 C8.38746,17.91553 12.92206,13.38123 18.49496,13.38123 L19.45756,13.38123 C21.84646,13.38123 23.78936,15.32403 23.78936,17.71303 L23.78936,22.61853 C23.78936,25.05263 22.14056,27.16393 19.77906,27.75453 L17.44396,28.33833 C15.51236,28.82173 14.16316,30.55003 14.16316,32.54103 L14.16316,33.11503 C14.16316,33.91103 13.51546,34.55893 12.71926,34.55893 Z",
    id: "Stroke-11",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.17146,26.85795 L29.08386,26.85795 C27.75686,26.85795 26.67726,25.77825 26.67726,24.45145 L26.67726,18.67565 C26.67726,15.75645 29.05256,13.38115 31.97166,13.38115 L37.26606,13.38115 L37.26606,15.26395 C37.26606,20.38275 34.04616,25.02925 29.25326,26.82715 L29.17146,26.85795 Z",
    id: "Stroke-13",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9302,8.0476 C43.9302,12.2633 40.5127,15.6808 36.2969,15.6808 C32.0812,15.6808 28.6637,12.2633 28.6637,8.0476 C28.6637,3.8319 32.0812,0.4143 36.2969,0.4143 C40.5127,0.4143 43.9302,3.8319 43.9302,8.0476",
    id: "Fill-15",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04275,
    y1: 5.7934,
    x2: 38.55115,
    y2: 10.3018,
    id: "Stroke-17",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-19",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21);
export default __webpack_public_path__ + "static/media/Group 21.54c2bc8a.svg";
export { ForwardRef as ReactComponent };